/* Copyright (C) 2021 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
// 2. Store and Types. 
// 3. Scripts. 

const ControlChars = { CrLf: '\r\n', Cr: '\r', Lf: '\n', Tab: '\t' };

export default class StringBuilder
{
	private value : string;
	public  length: number;

	constructor()
	{
		this.value  = '';
		this.length = this.value.length;
	}

	public Append(s: string)
	{
		this.value  = this.value + s;
		this.length = this.value.length;
	}

	public AppendLine(s?: string)
	{
		if ( s === undefined )
		{
			this.value  = this.value + ControlChars;
			this.length = this.value.length;
		}
		else
		{
			this.value  = this.value + s;
			this.length = this.value.length;
		}
	}

	public toString()
	{
		return this.value;
	}
}

